// extracted by mini-css-extract-plugin
export var activeDot = "_4o-c";
export var buttonContainer = "_4o-9";
export var channelButton = "_4o-a";
export var clickable = "_4o-d";
export var content = "_4o-0";
export var contentFull = "_4o-2";
export var contentThird = "_4o-1";
export var contentWrapper = "_4o-7";
export var description = "_4o-5";
export var heightShort = "_4o-f";
export var image = "_4o-3";
export var imageContainer = "_4o-4";
export var selectButton = "_4o-e";
export var spinnerContainer = "_4o-b";
export var titleContent = "_4o-8";
export var titleWrapper = "_4o-6";